// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { DeliveryDriver } from './delivery-driver';
import { DeliveryStack } from './delivery-stack';
import { DeliveryTrailer } from './delivery-trailer';
import { DeliveryTransportPlate } from './delivery-transport-plate';
import { DeliveryTruck } from './delivery-truck';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Delivery extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get stackCount() {
        return this.deliveryStacks ? this.deliveryStacks.length : 0;
    }

    get dealerList() {
      let dealerList = [];
      if (this.deliveryStacks && this.deliveryStacks.length > 0) {
          this.deliveryStacks.forEach((stack) => {
              if (stack.orderLineDetail.orderLine.order.dealer.companyName) {
                  if (!_.includes(dealerList, stack.orderLineDetail.orderLine.order.dealer.companyName)) dealerList.push(stack.orderLineDetail.orderLine.order.dealer.companyName);
              }
          });
      }
      return dealerList.join(' -- ');
  }

    get vinList() {
        let vINList = [];
        if (this.deliveryStacks && this.deliveryStacks.length > 0) {
            this.deliveryStacks.forEach((stack) => {
                if (stack.orderLineDetail) {
                    if (!_.includes(vINList, stack.orderLineDetail.vIN)) vINList.push(stack.orderLineDetail.vIN);
                }
            });
        }
        return vINList.join(' -- ');
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  completed?: Date;
  completedBy?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  driverId?: number;
  notes?: string;
  scheduled?: Date;
  stackCompleted?: Date;
  stackCompletedBy?: string;
  trailerId?: number;
  transportPlateId?: number;
  truckId?: number;
  deliveryStacks!: DeliveryStack[];
  driver!: DeliveryDriver;
  trailer!: DeliveryTrailer;
  transportPlate!: DeliveryTransportPlate;
  truck!: DeliveryTruck;
}

